import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Dialog, Transition } from '@headlessui/react'
import Button from '../Button/Button'

const MessageModal = ({
    title,
    message,
    onDone,
    onCancel,
    textDone,
    textCancel,
    isOpen,
    setIsOpen,
    maxWidth = 'md',
}) => {
    const closeModal = () => {
        if (setIsOpen) {
            setIsOpen(false)
            return
        }

        if (onDone) {
            onDone()
        }
    }

    const maxWidthClass = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBlack modalBackgroundBlur bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className={`w-full ${maxWidthClass[maxWidth]} transform overflow-hidden rounded-3xl md:p-12 p-4 text-center transition-all relative flex flex-col items-center justify-start gap-y-6`}
                                >
                                    <Dialog.Title
                                        as="h3"
                                        className="text-2.5xl text-white font-medium"
                                    >
                                        {title}
                                    </Dialog.Title>
                                    <p className="text-white text-base font-normal">
                                        {message}
                                    </p>
                                    <div className="w-full flex items-center justify-center gap-x-3">
                                        {textCancel && (
                                            <Button
                                                text={textCancel}
                                                variant="primary"
                                                onClick={() => {
                                                    onCancel()
                                                }}
                                                className="w-full"
                                                type="button"
                                            />
                                        )}
                                        <Button
                                            text={textDone}
                                            variant="secondary"
                                            onClick={() => {
                                                onDone()
                                            }}
                                            className="w-full"
                                            type="button"
                                        />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

MessageModal.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onDone: PropTypes.func,
    onCancel: PropTypes.func,
    textDone: PropTypes.string,
    textCancel: PropTypes.string,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
}

export default MessageModal
